var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C2.23858 0 0 2.23858 0 5V17C0 19.7614 2.23858 22 5 22H7.86193L9.29289 23.6602C9.68342 24.1133 10.3166 24.1133 10.7071 23.6602L12.1381 22H15C17.7614 22 20 19.7614 20 17V5C20 2.23858 17.7614 0 15 0H5Z",
    fill: "#B1B8C0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1094_158965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.90579 10.3333H10.086C11.3382 10.2917 12.3472 9.34167 12.3472 8.16667C12.3472 6.99167 11.3022 6 10.0049 6C8.70759 6 7.66255 6.975 7.64453 8.16667C7.64453 9.34167 8.64453 10.2917 9.90579 10.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3015 12.5664C11.4997 11.4414 8.51772 11.4414 6.6979 12.5664C5.1033 13.5581 5.1033 15.1747 6.6979 16.1581C8.50871 17.2831 11.4907 17.2831 13.3015 16.1581C14.8961 15.1664 14.8961 13.5581 13.3015 12.5664Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1094_158965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 11,
    fill: "white",
    transform: "translate(5.5 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavStore);
export default __webpack_public_path__ + "static/media/Nav_Store.83cd340ec6bef6289380535e3683c4d9.svg";
export { ForwardRef as ReactComponent };